/** سقف آپلود دستی فایل صوتی جلسه — باید با `stt.upload.max_file_size_mb` در Core یکی باشد. */
export const AUDIO_UPLOAD_MAX_MB = 300;

export const AUDIO_UPLOAD_MAX_BYTES = AUDIO_UPLOAD_MAX_MB * 1024 * 1024;

/** مهلت ارسال فایل تا ۳۰۰ مگابایت؛ باید از سقف اتصال وب‌سرور کوتاه‌تر نباشد. */
export const AUDIO_UPLOAD_TIMEOUT_MS = 900_000;

/** انتخابگر فایل موبایل: همهٔ صداها + کانتینرهای رایج ضبط گوشی */
export const AUDIO_UPLOAD_ACCEPT = [
  'audio/*',
  'video/mp4',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
  '.mp3',
  '.wav',
  '.m4a',
  '.aac',
  '.ogg',
  '.oga',
  '.opus',
  '.webm',
  '.mp4',
  '.amr',
  '.awb',
  '.3gp',
  '.3gpp',
  '.3g2',
  '.3ga',
  '.flac',
  '.caf',
  '.aiff',
  '.aif',
].join(',');

export const AUDIO_UPLOAD_FORMATS = [
  'M4A',
  'AAC',
  'MP3',
  'WAV',
  'OGG',
  'OPUS',
  'AMR',
  '3GP',
  'FLAC',
  'WebM',
  'MP4',
];

export const AUDIO_UPLOAD_ACCEPT_LABEL = AUDIO_UPLOAD_FORMATS.join('، ');

export const AUDIO_UPLOAD_PHONE_HINT = 'ضبط صدا با گوشی (آیفون و اندروید) هم پذیرفته می‌شود.';

export function audioUploadFormatsSentence() {
  const last = AUDIO_UPLOAD_FORMATS[AUDIO_UPLOAD_FORMATS.length - 1];
  const rest = AUDIO_UPLOAD_FORMATS.slice(0, -1).join('، ');
  return `فرمت‌های مجاز: ${rest} و ${last}`;
}

export function formatAudioUploadMegabytes(bytes) {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size <= 0) return '0';
  const mb = size / (1024 * 1024);
  if (mb < 10) return mb.toFixed(1).replace(/\.0$/, '');
  return String(Math.round(mb));
}

export function audioUploadLimitSentence() {
  return `حداکثر حجم فایل صوتی ${AUDIO_UPLOAD_MAX_MB} مگابایت است.`;
}

const REJECTED_UPLOAD_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'heic', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar',
]);

function fileExtension(file) {
  const name = typeof file?.name === 'string' ? file.name : '';
  const match = name.toLowerCase().match(/\.([a-z0-9]+)$/);
  return match ? match[1] : '';
}

export function validateAudioUploadFile(file) {
  if (!file) return 'فایل صوتی انتخاب نشده است.';
  if (typeof file.size === 'number' && file.size <= 0) {
    return 'فایل صوتی خالی است.';
  }
  if (typeof file.size === 'number' && file.size > AUDIO_UPLOAD_MAX_BYTES) {
    return `حجم این فایل ${formatAudioUploadMegabytes(file.size)} مگابایت است. حداکثر حجم مجاز ${AUDIO_UPLOAD_MAX_MB} مگابایت است.`;
  }
  const type = typeof file.type === 'string' ? file.type.toLowerCase() : '';
  const ext = fileExtension(file);
  if (type.startsWith('image/') || REJECTED_UPLOAD_EXTENSIONS.has(ext)) {
    return 'این فایل صدا نیست. یک فایل ضبط‌شده با گوشی انتخاب کنید.';
  }
  return null;
}
